import tracking from 'dibs-tracking';
import { getPromoCreative } from '../../homepage/helpers/getPromoCreative';
import {
    ATTRS_L1_CREATOR,
    ATTRS_ATTRIBUTE,
    DATA_GA_ID_KEY,
    DATA_GA_NAME_KEY,
} from '../../homepage/HpRespShopByModule/gaConstants';
import { TABLET_ITEMS_PER_PAGE } from '../constants';

function trackShopByItemsImpressions(items) {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: items.map((item, index) => {
            const position = index + 1;
            const attr = index < TABLET_ITEMS_PER_PAGE ? ATTRS_L1_CREATOR : ATTRS_ATTRIBUTE;

            return {
                id: `shop-by-${attr[DATA_GA_ID_KEY]}`,
                name: `Shop by ${attr[DATA_GA_NAME_KEY]}`,
                creative: getPromoCreative(item.link),
                position: position,
            };
        }),
    });
}

function trackShopByItemClick(item, index) {
    const position = index + 1;
    const attr = index < TABLET_ITEMS_PER_PAGE ? ATTRS_L1_CREATOR : ATTRS_ATTRIBUTE;

    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [
            {
                id: `shop-by-${attr[DATA_GA_ID_KEY]}`,
                name: `Shop by ${attr[DATA_GA_NAME_KEY]}`,
                creative: getPromoCreative(item.link),
                position: position,
            },
        ],
    });
}

function trackShopByLocationsImpressions(index, locationUrl = 'none', isPersonalized = false) {
    const variantType = isPersonalized ? 'personalized' : 'default';
    const position = index + 1;
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: [
            {
                id: 'shop-by-local-module',
                name: 'shop by local module',
                creative: locationUrl,
                position,
                variant: `${variantType} location`,
            },
        ],
    });
}

function trackShopByLocationClick(item, index) {
    const position = index + 1;
    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [
            {
                id: 'shop-by-location',
                name: 'Shop by Location',
                creative: getPromoCreative(item.link),
                position: position,
            },
        ],
    });
}

export {
    trackShopByItemsImpressions,
    trackShopByLocationsImpressions,
    trackShopByItemClick,
    trackShopByLocationClick,
};
